import React, { Component } from 'react'
import QRCode from 'qrcode.react';

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { FileCopy, Phone } from '@material-ui/icons';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck, faAppleAlt, faMobileAndroid, faDesktopAlt, faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { faApple, faAndroid, faChrome, faFirefox, faWindows, faSafari } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress, IconButton, InputAdornment } from "@material-ui/core";
import TextDivider from '../../../components/Divider/TextDivider';
import CustomInput from '../../../components/CustomInput/CustomInput';
import CheckAnimated from '../../../components/Icon/CheckAnimated';
import Api from '../../../api/Api.js';
import AuthEndpoints from '../../../api/AuthEndpoints';
import UserEndpoints from '../../../api/UserEndpoints';
import Loading from '../../../components/Loading/Loading';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class SMSDialog extends Component {

    state = {
        tab: 0,
        loading: false,
        testLoading: false,
        sms: '',

        contact_number: "",
        contact_numberInvalid: false,
        contact_numberAlreadyTaken: false,

        enabled: false,

        otp: '',
        otpInvalid: false,
        otpTestSuccess: false
    }

    componentDidMount() {
        this.setState({ contact_number: this.props.contact_number || "" })
    }

    testSMS() {
        this.setState({ testLoading: true }, () => {
            Api.get(AuthEndpoints.validateSMSOtp, { otp: this.state.otp })
                .then(({ data }) => {
                    this.setState({ otpInvalid: data == false, otpTestSuccess: data == true, testLoading: false })
                })
                .catch((e) => {
                    this.setState({ testLoading: false, otpInvalid: true });
                    console.error(e)
                })
        })
    }

    addSMSValidation() {
        if (!/^[0-9]{10,20}$/.test(this.state.contact_number)) {
            this.setState({ contact_numberInvalid: true });
            return;
        }

        this.setState({ loading: true }, () => {
            Api.get(AuthEndpoints.addSMSAuth, { new_contact_number: this.state.contact_number })
                .then(({ data }) => {
                    Api.get(AuthEndpoints.sendTestOtpSMS)
                        .then(() => {
                            this.setState({ loading: false, tab: 1, enabled: true });
                            this.props.refresh();
                        })
                        .catch((e) => {
                            this.setState({ loading: false })
                            console.error(e)
                        })
                })
                .catch((e) => {
                    this.setState({ loading: false })
                    console.error(e)
                })
        })
    }

    checkContactNumber() {
        const testNumber = this.state.contact_number;

        Api.get(UserEndpoints.isContactNumberUsed, { contact_number: testNumber })
            .then(({ data }) => {
                if (data == true) {
                    if (testNumber === this.state.contact_number)
                        this.setState({ contact_numberAlreadyTaken: true })
                } else {
                    this.setState({ contact_numberAlreadyTaken: false })
                }
            })
            .catch((e) => {
                console.error(e)
            })
    }

    render() {
        const { classes } = this.props;

        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                scroll="body"
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
                PaperProps={{ style: { overflow: 'visible' } }}
            >
                <DialogContent style={{ padding: 0, width: '100%' }}>
                    <Tabs
                        value={this.state.tab}
                        onChange={(event, value) => this.setState({ tab: value })}
                        variant="fullWidth"
                        indicatorColor="primary"
                        textColor="primary"
                        style={{
                            backgroundColor: '#EEEEEE',
                            boxShadow: "0 10px 30px -6px rgba(0, 0, 0, 0.1), 0 4px 25px 0px rgba(0, 0, 0, 0.03), 0 8px 10px -2px rgba(0, 0, 0, 0.05)",
                            borderTopLeftRadius: 4,
                            borderTopRightRadius: 4
                        }}
                    >
                        <Tab style={{ flex: 1, flexGrow: 1, ...(this.state.tab === 0 ? { backgroundColor: '#ffffff' } : {}) }} label="Setup" />
                        <Tab style={{ flex: 1, flexGrow: 1, ...(this.state.tab === 1 ? { backgroundColor: '#ffffff' } : {}) }} label="Test" disabled={!this.state.enabled} />
                        <Tab style={{ flex: 1, flexGrow: 1, ...(this.state.tab === 2 ? { backgroundColor: '#ffffff' } : {}) }} label="Done" disabled={!this.state.enabled} />
                    </Tabs>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: 20 }}>
                        {this.state.tab === 0 && (
                            <div style={{ textAlign: 'center' }}>
                                <CustomInput
                                    labelText={
                                        <span>
                                            {this.state.contact_numberAlreadyTaken ? "Contact Number Already Taken" : "Contact Number"} <small>(must be unique)</small>
                                        </span>
                                    }
                                    error={this.state.contact_numberAlreadyTaken || this.state.contact_numberInvalid}
                                    id="contact_number"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        onChange: event => {
                                            if (/^[0-9]{0,20}$/.test(event.target.value))
                                                this.setState({ contact_number: event.target.value, contact_numberAlreadyTaken: false, contact_numberInvalid: false })
                                        },
                                        endAdornment: (
                                            <InputAdornment
                                                position="end"
                                                className={classes.inputAdornment}
                                            >
                                                <Phone className={classes.inputAdornmentIcon} />
                                            </InputAdornment>
                                        ),
                                        onKeyPress: (e) => {
                                            if (e.key === 'Enter') {
                                                this.addSMSValidation();
                                            }
                                        },
                                        value: this.state.contact_number,
                                    }}
                                />
                            </div>
                        )}
                        {this.state.tab === 1 && (
                            <div style={{ textAlign: 'center' }}>
                                <CustomInput
                                    labelText={(this.state.otpInvalid ? "Invalid Pin" : this.state.otpTestSuccess ? "Pin Verified" : "Enter Pin")}
                                    id="otp"
                                    success={this.state.otpTestSuccess}
                                    error={this.state.otpInvalid}
                                    labelProps={{
                                        style: {
                                            fontSize: 24,
                                            textAlign: 'center'
                                        }
                                    }}
                                    inputProps={{
                                        onChange: (event) => {
                                            if (/^[0-9]{0,6}$/.test(event.target.value))
                                                this.setState({ otp: event.target.value, otpInvalid: false });
                                        },
                                        value: this.state.otp,
                                        onKeyPress: (e) => {
                                            if (e.key === 'Enter') {
                                                this.testSMS();
                                            }
                                        },
                                        inputProps: {
                                            style: {
                                                fontSize: 24,
                                                letterSpacing: 4,
                                                textAlign: 'center'
                                            }
                                        }
                                    }}
                                />

                                <Button
                                    onClick={() => this.testSMS()}
                                    color="rose"
                                    round
                                >
                                    Check
                                        </Button>
                            </div>
                        )}
                        {this.state.tab === 2 && (
                            <div style={{ textAlign: 'center', paddingTop: 20 }}>
                                <div style={{ width: '35%', height: 'auto', marginLeft: 'auto', marginRight: 'auto', marginBottom: 30 }}>
                                    <CheckAnimated />
                                </div>

                                <h1 style={{ color: 'var(--green)' }}>You're ready to go</h1>

                                <h3 style={{ color: 'var(--green)' }}>Just click below and get started</h3>
                            </div>
                        )}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>
                    {
                        this.state.loading ?
                            <Loading />
                            :
                            (
                                this.state.tab === 2 ?
                                    <Button
                                        onClick={() => this.props.close()}
                                        color="success"
                                        round
                                    >
                                        Start Using SMS
                                        &nbsp;&nbsp;
                                        <FontAwesomeIcon icon={faCheck} />
                                    </Button>
                                    :
                                    (
                                        this.state.tab === 0 ?
                                            <Button
                                                onClick={() => this.addSMSValidation()}
                                                color="primary"
                                                round
                                            >
                                                Enable SMS and Continue
                                                &nbsp;&nbsp;
                                                <FontAwesomeIcon icon={faChevronRight} />
                                            </Button>
                                            :

                                            <Button
                                                onClick={() => this.setState({ tab: (this.state.tab + 1) })}
                                                color="primary"
                                                round
                                            >
                                                Next
                                                &nbsp;&nbsp;
                                                <FontAwesomeIcon icon={faChevronRight} />
                                            </Button>
                                    )
                            )
                    }
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(SMSDialog);